/**
 * ### AOP Util
 *
 * Our solution to decouple modules and
 * provide a soluiton to get SRP and OCP
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export default class AOP {
  public static add<T>(target: T, ...aspects: any[]): T {
    const get = (obj, prop, receiver) => {
      if (prop !== 'execute' || typeof obj[prop] !== 'function') {
        return Reflect.get(obj, prop, receiver);
      }
      return async function (...args) {
        const run = pointcut => aspects.filter(aspect => aspect[prop]).forEach(aspect => aspect[prop](...args)[pointcut]?.());
        run('before');
        try {
          let result = Reflect.apply(obj[prop], obj, args);
          run('during');
          result = await result;
          result = aspects.filter(aspect => aspect[prop]).reduce((acc, aspect) => aspect[prop](...args).return?.(acc) ?? acc, result);
          run('after');
          return result;
        } catch (error) {
          let caughtError = error;
          caughtError = aspects.filter(aspect => aspect[prop]).reduce((acc, aspect) => aspect[prop](...args).catch?.(acc) ?? acc, caughtError);
          run('after');
          throw caughtError;
        }
      };
    };

    return new Proxy(target, { get });
  }
}
